import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import common from './modules/common'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    websock:null,
    printWebsockt:null,
    callWebsockt:null,
    userdata:[],
  },
  modules: {
    common,
    user
  },
  mutations: {
    userdata(state, newval) {
      state.userdata = newval
    },
    updateWebsock (state, res) {
      state.websock = res
    },
    updatePrintWebsock (state, res) {
      state.printWebsockt = res
    },
    updateCallWebsock (state, res) {
      state.callWebsockt = res
    },
    // 重置vuex本地储存状态
    resetStore (state) {
      Object.keys(state).forEach((key) => {
        state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
      })
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
